/** @format */
import mochiVayTay from "../assets/images/mochiVayTay.png";
import ButtonCircle from "../component/common/button/ButtonCircle";
import iconTypeCode from "../assets/images/iconTypeCode.png";
import { useState, useRef, useEffect } from "react";
import { handleSendCall } from "./services/SendCode";
import { getInfoUser } from "./services/getInfoUser";
import { getCookie, delete_cookie } from "../untils/helpers";

const ScreenTypeCode = ({ setPageLoginSignup }) => {
    const [isActive, setIsActive] = useState(false);
    const [err, setErr] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState("");
    const [success, setSuccess] = useState("");

    const handleSendCode = async () => {
        setIsLoading(true);
        const result = await handleSendCall(value, getCookie("user_token"));
        setIsLoading(false);
        if (result?.data?.code === 0) {
            setErr(result?.data?.msg || "Nạp mã không thành công");
            setSuccess("");
        }
        //  if (result?.data?.code === 1)
        else {
            setErr("");
            setSuccess("Nạp mã thành công");
        }
    };

    useEffect(() => {
        if (value.length === 19) {
            setIsActive(true);
        } else {
            setIsActive(false);
        }
    }, [value.length === 19]);

    const handleSetValue = (e) => {
        setValue(e.target.value);
    };

    const handleChangeValue = (e) => {
        let valueInput = e.target.value;
        if (e.key === "Backspace" || e.key.startsWith("Arrow")) {
            setValue(valueInput);
            return;
        }

        let valueFormat = valueInput.replace(/[^a-zA-Z0-9]/g, "");
        if (valueFormat.length > 16) {
            valueFormat = valueFormat.substring(0, 16);
        }
        const regex = new RegExp(`.{1,${4}}`, "g");
        if (valueFormat.length > 4) {
            valueFormat = valueFormat.match(regex).join("-");
        }
        setValue(valueFormat);
    };
    const handleClickChangeAccount = () => {
        setErr("");
        setPageLoginSignup((prev) => ["login", ...prev]);
        // setIsOpenPopupLoginSignup({ type: "login", isOpen: true });
    };
    return (
        <div className="wrap_screenTypeCode">
            <div className="screenTypeCode_image">
                <img src={mochiVayTay} alt="image" />
            </div>

            <h1 className="screenTypeCode_title">NẠP MÃ THẺ HỌC</h1>
            <div className="screenTypeCode_message_type-code-for-account">
                <section>Nhập mã cho tài khoản</section>{" "}
                <span>{getCookie("email")}</span>
            </div>
            <div className="screenTypeCode_input">
                <div className="input-group ">
                    <span
                        className="input-group-text screenTypeCode_input_groupIconCode"
                        id="basic-addon1">
                        <img src={iconTypeCode} alt="icon code" />
                    </span>
                    <input
                        value={value}
                        type="text"
                        onChange={handleSetValue}
                        onKeyUp={handleChangeValue}
                        placeholder="Nhập mã thẻ học của bạn"
                        className="form-control"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                    />
                </div>
                <p className="screenTypeCode_errMsg">{err}</p>
                <p className="screenTypeCode_successMsg">{success}</p>
            </div>

            <div className="screenTypeCode_buttons">
                {isActive ? (
                    <ButtonCircle
                        isLoading={isLoading}
                        height={40}
                        green={"true"}
                        onClick={() => !isLoading && handleSendCode()}
                        buttonText="KÍCH HOẠT MÃ"
                    />
                ) : (
                    <ButtonCircle
                        height={40}
                        gray={"true"}
                        buttonText="KÍCH HOẠT MÃ"
                    />
                )}
            </div>
            <div className="screenTypeCode_footer">
                <p onClick={handleClickChangeAccount}>
                    Mình muốn nạp mã cho tài khoản khác
                </p>
            </div>
        </div>
    );
};
export default ScreenTypeCode;
